import { TokenABI } from "@abi/TokenABI";
import config from "@config";
import type { Address } from "viem";
import { useReadContract } from "wagmi";

const useTokenBalance = (account: string) => {
	const { data } = useReadContract({
		abi: TokenABI,
		address: config.web3.vpndAddress as Address,
		args: [account],
		functionName: "balanceOf",
	}) ?? { data: 0 };

	const tokenBalance = data;
	const tokenBalanceFormatted = +tokenBalance?.toString() / 1e18;
	const tokenBalanceFormattedShortened = (+tokenBalance?.toString() / 1e18)
		?.toFixed(2)
		?.toString();

	return {
		tokenBalance,
		tokenBalanceFormatted,
		tokenBalanceFormattedShortened,
	};
};

export default useTokenBalance;
